






























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3,logoutPanel,changeBalancePanel,changeScorePanel } from "@/components";
import { TbGoods, TbMember } from '@/http';
import saleOrder from "./components/saleOrder.vue";
import returnOrder from "./components/returnOrder.vue";
import balanceDetail from "./components/balanceDetail.vue";
import scoreDetail from "./components/scoreDetail.vue";
import addVipPanel from "./components/addVipPanel.vue";
import Bus from '@/common/util/bus';
import { fmoney } from '@/common/money';
import { Toast,Dialog } from 'vant';
@Component({
    components: {
        padHeadPanel3,logoutPanel,saleOrder,returnOrder,balanceDetail,scoreDetail,addVipPanel,changeBalancePanel,changeScorePanel
    },
})
export default class vipDetail extends Vue {
    public $refs: {
    };
    id="";

    form:any={};

    active = 0;
    tabList=[
        {
            label:'销售订单',
            value:0,
        },
        {
            label:'退货订单',
            value:1,
        },
        {
            label:'余额明细',
            value:2,
        },
        {
            label:'积分明细',
            value:3,
        },
    ]
 

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=2;

    addVipShow=false;

    // 余额调整弹窗
    balanceShow = false;

    // 积分调整弹窗
    scoreShow = false;

    fmoney = fmoney;

    userInfo = {};

    get getNameSty(){
        let str="";
        switch (this.form.gradeName) {
            case '白银会员':
                str="c1"
                break;
            case '黄金会员':
                str="c2"
                break;
            case '铂金会员':
                str="c3"
                break;
            case '钻石会员':
                str="c4"
                break;
            case '黑钻会员':
                str="c5"
                break;
        
            default:
                str="c6"
                break;
        }
        return str;
    }

    created() {
        this.id = this.$route.query.id;
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    }
    async mounted(){
        await this.init();
        let allotactive = localStorage.getItem("allotactive")
        ? Number(localStorage.getItem("allotactive"))
        : 0;
        this.active = allotactive;  
        localStorage.removeItem('allotactive'); 


    }
   
    async init(){
       let res = await TbMember.GetTbMemberById({id:this.id});
       this.form = res;
    }
    
    /**提示弹窗 */
    async tipConfirm(){
       
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
    changeTab(v){
        this.active = v.value;
    }
    closeAdd(){
        this.addVipShow = false;
    }
    confirmSaveAdd(val){
        if(val){
            this.init();
        }else{
            this.$router.go(-1);
        }
    }
    async showEdit(){
        let res = await TbMember.GetTbMemberById({id:this.form.id});
        this.addVipShow = true;
        this.$nextTick(()=>{
            this.$refs['addVipPanel'].init(res);
        })
    }
    closeBalance(){
        this.balanceShow = false;
    }
    closeScore(){
        this.scoreShow = false;
    }
    showScore(){
        if(!this.hasAuth('2902')){
            Toast('当前用户不具备修改积分的权限！');
            return;
        }
        this.scoreShow = true;
    }
    confirmScoreSave(){
        this.init();
        Bus.$emit("refreshVipDetail")
    }
    showBalance(){
        if(!this.hasAuth('2901')){
            Toast('当前用户不具备修改余额的权限！');
            return;
        }
        this.balanceShow = true;
    }
    confirmBalanceSave(){
        this.init();
        Bus.$emit("refreshVipDetail")
    }
    goRecharge(){
        localStorage.setItem("allotactive",this.active)
        this.$router.push(`/pad/vip/recharge?id=${this.form.id}`);
    }

    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/vipDetail.vue